export default {
  market: {
    id: 'bo_seller.listings.listings_table.market_column',
    defaultMessage: 'Market',
  },
  minPrice: {
    id: 'bo_seller.listings.listings_table.min_price_column',
    defaultMessage: 'Minimum price',
  },
  targetPrice: {
    id: 'bo_seller.listings.listings_table.target_price_column',
    defaultMessage: 'Target price',
  },
  backBoxPrice: {
    id: 'bo_seller.listings.listings_table.backbox_price_column',
    defaultMessage: 'BackBox price',
  },
  backBoxPriceTooltip: {
    id: 'bo_seller.listings.listings_table.backbox_price_column_tooltip',
    defaultMessage:
      'The BackBox price is a pricing strategy you can choose to get your product in front of more customers. When your listing wins the BackBox, your listing is the featured offer that customers see when they search for your product and grade.',
  },
  salesMaximizerPriceTooltip: {
    id: 'bo_seller.listings.listings_table.sales_maximizer_price_column_tooltip',
    defaultMessage:
      'The Sales Maximizer Price is a recommended strategy that has the potential to increase your sell-through rate. We determine this price recommendation using platform-specific pricing and sales data from the last week and month, as well as average order and BackBox prices. If you choose the Sales Maximizer Price strategy, the pricing recommendations are applied every 24 hours.',
  },
  salesMaximizerPrice: {
    id: 'bo_seller.listings.listings_table.sales_maximizer_price_column',
    defaultMessage: 'Sales maximizer price',
  },
  backBoxPriceTooltipDynamicPricingUp: {
    id: 'bo_seller.listings.listings_table.backbox_price_column_tooltip_dynamic_pricing_up',
    defaultMessage:
      "This is the current BackBox price for your listing in each market. The price shown doesn't include the adjustment fee, if applicable.",
  },
  pricingStrategyTooltip: {
    id: 'bo_seller.listings.listings_table.pricing_strategy_column_tooltip',
    defaultMessage:
      'Pricing strategies can help you outsell your competition. Maximize your sales numbers or take advantage of deals by updating your prices to our recommended prices. ',
  },
  pricingStrategy: {
    id: 'bo_seller.listings.listings_table.pricing_strategy_column',
    defaultMessage: 'Pricing strategy',
  },
  minimumPriceLabel: {
    id: 'bo_seller.listings.listings_table.minimum_price_label',
    defaultMessage: 'Min.({currency})',
  },
  minimumPriceAboveTargetPriceError: {
    id: 'bo_seller.listings.listings_table.minimum_price_below_target_price_error',
    defaultMessage: 'The minimum price must be below the target price',
  },
  targetPriceLabel: {
    id: 'bo_seller.listings.listings_table.target_price_label',
    defaultMessage: 'Target ({currency})',
  },
  targetPriceIsTooHighError: {
    id: 'bo_seller.listings.listings_table.target_price_is_too_high_error',
    defaultMessage:
      "Your target price can't be more than {limit}% higher than the minimum price",
  },
  targetPriceExceedsPriceWhenSoldNewError: {
    id: 'bo_seller.listings.listings_table.target_price_exceeds_price_when_sold_new_error',
    defaultMessage:
      'The target price must be lower than the price when sold new: {newPrice}',
  },
  savePriceButton: {
    id: 'bo_seller.listings.listings_table.save_price.button',
    defaultMessage: 'Save',
  },
  winBackboxButton: {
    id: 'bo_seller.listings.listings_table.win_backbox.button',
    defaultMessage: 'Win BackBox',
  },
  defaultBackboxTagLabel: {
    id: 'bo_seller.listings.listings_table.default_backbox_tag_label',
    defaultMessage: 'BackBox',
  },
  hasBackboxTagLabel: {
    id: 'bo_seller.listings.listings_table.has_backbox_tag_label',
    defaultMessage: "You've got the BackBox",
  },
  hasBackboxPriceLabel: {
    id: 'bo_seller.listings.listings_table.has_backbox_price_label',
    defaultMessage: "Your product's got eyes on it",
  },
  listingIsOfflineLabel: {
    id: 'bo_seller.listings.listings_table.listing_is_offline_label',
    defaultMessage: 'Listing offline',
  },
  listingIsOfflineTooltip: {
    id: 'bo_seller.listings.listings_table.listing_is_offline_tooltip',
    defaultMessage:
      'Your listing isn’t live in this market right now. Click for details.',
  },
  otherlistingHasBackboxLabel: {
    id: 'bo_seller.listings.listings_table.other_listing_has_backbox_label',
    defaultMessage: 'You have another listing with the BackBox',
  },
  doesNotHaveBackboxLabel: {
    id: 'bo_seller.listings.listings_table.does_not_have_backbox_label',
    defaultMessage: "Don't lose these customers",
  },
  winBackBox: {
    id: 'bo_seller.listings.listings_table.win_back_box',
    defaultMessage: 'Win BackBox to start selling',
  },
  winAllBackboxesButton: {
    id: 'bo_seller.listings.listings_table.win_all_backboxes.button',
    defaultMessage: 'Win all BackBoxes',
  },
  maximizeAllSalesButton: {
    id: 'bo_seller.listings.listings_table.maximize_all_sales.button',
    defaultMessage: 'Maximize all sales',
  },
  pricingStrategyUpdate: {
    id: 'bo_seller.listings.listings_table.pricing_strategy_update.button',
    defaultMessage: 'Maximize sales',
  },
  unlockDealButton: {
    id: 'bo_seller.listings.listings_table.unlock_deal.button',
    defaultMessage: 'Unlock deal',
  },
}
